<template>
	<div class="zzAdminBox" v-loading.fullscreen.lock="fullscreenLoading">
		<dialogBox :dialogFlag="delFlag" @qrsFn="delFn" rigTxt="确认" rigBg="#D33931" @callFn="delFlag = false" title="删除">
			<p style="text-align: center">是否确认删除</p>
		</dialogBox>
		<div class="zzAdminTabs">
			<div class="zzAdminTab">
				<div class="zzAdminItem" @click="tabFn(6)" :class="flags == 6 ? 'active' : ''">英文小说</div>
				<div class="zzAdminItem" @click="tabFn(4)" :class="flags == 4 ? 'active' : ''">荐阅外刊</div>
				<div class="zzAdminItem" @click="tabFn(5)" :class="flags == 5 ? 'active' : ''">双语节目</div>
				<div class="zzAdminItem" @click="tabFn(7)" :class="flags == 7 ? 'active' : ''">优质课</div>
			</div>
		</div>
		<div class="zzAdminConts">
			<div class="zzAdminCont" v-if="!perData.length">
				<el-empty description="暂无收藏"></el-empty>
			</div>
			<div class="zzAdminCont" v-if="perData.length">
				<div class="zzAdminG" v-for="(item, index) in perData" :key="index" @click="meiwBtn(item)">
					<div class="zzAdminItemImg">
						<el-image :src="$imgFn(item.resourceFileName, 1)" lazy></el-image>
					</div>
					<div class="zzAdminItemP">
						<div class="zzAdminItemTit">
							<p>{{ item.title }}</p>
							<div class="infoMyVip infoMyPut" v-if="item.limitsAuthority == 0">
								<i class="el-icon-user-solid"></i>
								<span>普通老师</span>
							</div>
							<div class="infoMyVip" v-if="item.limitsAuthority == 1">
								<img src="@/assets/img/hys.svg" alt="" />
								<span>会员老师</span>
							</div>
						</div>
						<div class="zzAdminItemJj">
							<div class="zzAdminItemJjI" :class="`zzAdminItemJjI${(tabList.indexOf(i) + 1) % 6}`" v-for="(i, index) in item.keywords?.split(',')" :key="index">
								{{ i }}
							</div>
						</div>
						<div class="zzAdminItemFot">
							<div class="zzAdminItemk">
								<img src="@/assets/img/xiazai.svg" alt="" />
								<span>下载量：{{ item.downloadNum || 0 }}</span>
							</div>
							<div class="zzAdminItemk">日期：{{ (item.releaseTime || item.createTime) | momentYR('YYYY年MM月DD日') }}</div>
							<!-- <div class="zzAdminItemk">
                编写人：{{item.createNickName}}
              </div> -->
						</div>
					</div>
					<div class="zzAdminItemDel" @click.stop="delBtn(item)">
						<img src="@/assets/img/shanc.svg" alt="" />
					</div>
				</div>
			</div>
			<fenye v-if="perData.length" :total="total" ref="fybox" @dataFn="perList" />
		</div>
	</div>
</template>

<script>
import dialogBox from '@/components/pubComponents/dialogBox';
import fenye from '@/components/pubComponents/fenye';

export default {
	name: 'kuozhanYd',
	data() {
		return {
			delFlag: false,
			flags: 6,
			perData: [],
			total: 0,
			tabList: [],
			documentResourceId: '',
			fullscreenLoading: false
		};
	},
	components: {
		dialogBox,
		fenye
	},
	methods: {
		tabFn(type) {
			this.flags = type;
			this.init();
		},
		perList(data) {
			let pre = '';
			if (data) {
				pre = {
					pageNum: data.pageNum,
					pageSize: this.$refs['fybox']?.pageSize || 10
				};
			} else {
				pre = {
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				};
			}
			this.fullscreenLoading = true;
			this.$http
				.get('api/app/yydDocumentResource/list', {
					params: {
						type: this.flags,
						isCollect: 1,
						...pre
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						this.perData = res.rows || [];
						this.total = res.total;
					}
				});
		},
		init() {
			this.$http
				.get('api/app/yydDocumentResource/documentResourceIdKeywords/list', {
					params: {
						type: this.flags
					}
				})
				.then((res) => {
					if (res.code == 200) {
						this.tabList = res.data.map((item) => {
							return item.resourceKeywordsName;
						});
						console.log(this.tabList, 8888);
					}
				});
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		btns(cont) {
			this.$emit('currCompBtn', cont);
		},
		delBtn(item) {
			this.documentResourceId = item.documentResourceId;
			this.delFlag = true;
		},
		delFn() {
			console.log(this.documentResourceId, 777);
			if (this.documentResourceId) {
				this.fullscreenLoading = true;
				this.$http.post(`api/app/yydCollect/cancel/2/${this.documentResourceId}`).then((res) => {
					this.fullscreenLoading = true;
					if (res.code == 200) {
						this.delFlag = false;
						this.$message({
							type: 'success',
							message: '删除成功'
						});
						this.perList();
					}
				});
			}
		},
		meiwBtn(item) {
			this.$router.push({
				path: './hbDec',
				query: {
					type: 5,
					flags: 1,
					conTxt: 1,
					txt: item.title,
					classType: this.flags,
					documentResourceId: item.documentResourceId,
					yzType: '1',
					crumFlag: 1,
					tabFtxt: ['首页', '扩展阅读']
				}
			});
		}
	},
	activated() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.zzAdminBox {
	flex: 1;
	margin-left: 10px;
	.zzAdminConts {
		background: #ffffff;
		border-radius: 0px 0px 6px 6px;
		padding: 0 15px;
		.zzAdminCont {
			margin-bottom: 100px;
			min-height: 450px;
			.zzAdminG {
				display: flex;
				padding: 15px 0;
				border-bottom: 1px solid #f8f8f8;
				align-items: center;
				&:last-of-type {
					border-bottom: none;
				}
				.zzAdminItemImg {
					width: 74px;
					height: 74px;
					border-radius: 8px;
					margin-right: 10px;
					cursor: pointer;
				}
				.zzAdminItemP {
					cursor: pointer;
					width: 650px;
					.zzAdminItemJj {
						display: flex;
						align-items: center;
						.zzAdminItemJjI {
							padding: 0 10px;
							height: 20px;
							font-size: 12px;
							text-align: center;
							line-height: 20px;
							border-radius: 4px;
							margin-right: 10px;
							margin-bottom: 5px;
						}
						.zzAdminItemJjI0 {
							background: #fef7f0;
							color: #f7860f;
						}
						.zzAdminItemJjI1 {
							background: #fef7f0;
							color: #f7860f;
						}
						.zzAdminItemJjI2 {
							background: #f6fcf1;
							color: #5ec009;
						}
						.zzAdminItemJjI3 {
							background: #f1f7fe;
							color: #1675e5;
						}
						.zzAdminItemJjI4 {
							background: #fbf3ff;
							color: #bf2ff9;
						}
						.zzAdminItemJjI5 {
							background: #f2f7f3;
							color: #1d7b3a;
						}
					}
					.zzAdminItemFot {
						display: flex;
						align-items: center;
						.zzAdminItemk {
							display: flex;
							align-items: center;
							color: #8f9190;
							font-size: 12px;
							margin-right: 29px;
							img {
								width: 15px;
								height: 15px;
								margin-right: 4px;
							}
						}
					}
					.zzAdminItemC {
						color: #aeaeae;
						font-size: 14px;
						width: 647px;
						margin-bottom: 5px;
						overflow: hidden; /* 确保超出容器的内容被裁剪 */
						white-space: nowrap; /* 确保文本在一行内显示 */
						text-overflow: ellipsis; /* 超出部分显示省略号 */
					}
					.zzAdminItemTit {
						display: flex;
						align-items: center;
						margin-bottom: 6px;
						.zzAdminItemStat {
							width: 44px;
							height: 20px;
							background: #1d7b3a;
							font-size: 14px;
							color: #fff;
							margin-right: 10px;
							border-radius: 4px;
							text-align: center;
							line-height: 20px;
						}
						p {
							font-size: 16px;
							color: #000000;
							font-weight: bold;
						}
						.zzAdminItemYuy {
							display: flex;
							align-items: center;
							color: #93571c;
							font-size: 14px;
							margin-left: 25px;
							img {
								width: 14px;
								height: 14px;
								margin-right: 5px;
							}
						}
					}
				}
				.zzAdminItemDel {
					flex: 1;
					width: 20px;
					height: 22px;
					margin-right: 32px;
					cursor: pointer;
					text-align: right;
				}
			}
		}
	}
	.zzAdminTabs {
		height: 50px;
		background: #ffffff;
		border-radius: 6px 6px 0px 0px;
		display: flex;
		justify-content: space-between;
		padding: 0 15px 0 26px;
		border-bottom: 1px solid #f3f4f7;
		.zzAdminTab {
			display: flex;
			font-size: 14px;
			color: #979797;
			align-items: center;
			.zzAdminItem {
				margin-right: 52px;
				cursor: pointer;
			}
			.active {
				color: #000;
				font-weight: bold;
			}
		}
		.zzAdminUp {
			display: flex;
			align-items: center;
			color: #1d7b3a;
			font-size: 14px;
			height: 100%;
			cursor: pointer;
			img {
				width: 16px;
				height: 16px;
				margin-right: 7px;
			}
		}
	}
}
.infoMyVip {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 75px;
	height: 18px;
	background: linear-gradient(90deg, #fde6d1 0%, #fdd7b3 100%);
	border-radius: 4px;
	color: #93571c;
	font-size: 12px;
	margin-left: 10px;

	img {
		width: 14px;
		height: 14px;
		margin-right: 2px;
	}
}
.infoMyPut {
	background: linear-gradient(90deg, rgba(97, 161, 255, 0.22) 0%, rgba(0, 118, 255, 0.31) 100%);
	color: #0c7bfd;
}
</style>
